import React from 'react';

const SpinnerComponent = ({ size }) => (
  <div className="spinner-container">
    <i className="fa fa-refresh fa-spin" style={{ fontSize: size }} />
  </div>
);

export default SpinnerComponent;



// WEBPACK FOOTER //
// src/components/SpinnerComponent.jsx